import { render } from "./CoinSubscriptions.vue?vue&type=template&id=2d395434&scoped=true&ts=true"
import script from "./CoinSubscriptions.vue?vue&type=script&lang=ts"
export * from "./CoinSubscriptions.vue?vue&type=script&lang=ts"

import "./CoinSubscriptions.vue?vue&type=style&index=0&id=2d395434&scoped=true&lang=css"

import exportComponent from "/Users/rickvanwell/Work/Signals/webui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d395434"]])

export default __exports__